import { getLocale } from "../runtime";

const sv_notifyformemaillabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `E-postadress`
};

const notifyformemaillabel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notifyformemaillabel(inputs)
	return "notifyFormEmailLabel";
};

export { notifyformemaillabel as "notifyFormEmailLabel" };